// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"189eb4a4","194":"3914e230","405":"6cfbf0fc","566":"b54570be","717":"bd4c887a","845":"cedff38f"}[chunkId] + ".chunk.js";
};